import useTranslation from '../../customHooks/useTranslation';
import LogoMark from './LogoMark';

// The title block of the whole drawing set: who issued it and under which company data.
export default function Footer() {
	const t = useTranslation();
	const f = t.footer;
	const year = new Date().getFullYear();

	return (
		<footer className='border-t border-ink-line bg-sheet-deep'>
			<div className='mx-auto max-w-[1320px] px-4 py-10 sm:px-8'>
				<div className='grid border-l border-t border-ink-line sm:grid-cols-2 lg:grid-cols-[auto_2fr_1fr_1fr]'>
					<div className='flex items-center gap-3 border-b border-r border-ink-line px-4 py-4'>
						<LogoMark className='h-10 w-10' />
						<span className='type-wide text-lg font-bold leading-tight text-ink'>
							Kamil Pfaff
							<span className='lettering mt-1 block text-[0.62rem] font-semibold text-ink-faint'>{t.hero.role}</span>
						</span>
					</div>
					{/* Company data: the registered name and numbers lead, the address is small print. */}
					<div className='border-b border-r border-ink-line px-4 py-4'>
						<p className='lettering text-[0.62rem] text-ink-faint'>{f.companyLabel}</p>
						<p className='mt-1 font-semibold text-ink'>{f.company}</p>
						<dl className='mt-1 flex flex-wrap gap-x-4 gap-y-0.5 text-sm text-ink-soft'>
							<div className='flex items-baseline gap-1.5'>
								<dt className='lettering text-[0.62rem] text-ink-faint'>NIP</dt>
								<dd>638-185-36-29</dd>
							</div>
							<div className='flex items-baseline gap-1.5'>
								<dt className='lettering text-[0.62rem] text-ink-faint'>REGON</dt>
								<dd>525526840</dd>
							</div>
						</dl>
						<p className='mt-2 text-xs text-ink-faint'>{f.address}</p>
					</div>
					<Cell label={f.revision}>
						{f.revisionValue}, {year}
					</Cell>
					<div className='border-b border-r border-ink-line px-4 py-4'>
						<a href='#top' className='lettering inline-flex items-center gap-2 text-label text-ink-soft transition-colors hover:text-redline'>
							<svg viewBox='0 0 12 12' className='h-3 w-3' aria-hidden='true'>
								<path d='M6 10V2M2.5 5.5 6 2l3.5 3.5' fill='none' stroke='currentColor' strokeWidth='1.4' />
							</svg>
							{f.top}
						</a>
					</div>
				</div>
				<p className='mt-6 text-sm text-ink-faint'>
					© {year} Designed and built by <a href="https://pfaff.app" className="hover:text-redline transition-colors">Kamil Pfaff Konsulting IT</a>.
				</p>
			</div>
		</footer>
	);
}

function Cell({ label, children }: { label: string; children: React.ReactNode }) {
	return (
		<div className='border-b border-r border-ink-line px-4 py-4'>
			<p className='lettering text-[0.62rem] text-ink-faint'>{label}</p>
			<p className='mt-1 text-sm text-ink-soft'>{children}</p>
		</div>
	);
}
